import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ReactTemplate } from '@bingads-webui-react/react-template';

import { ConfirmDialog } from '../common';
import { useStyles } from '../styles/consolidated-billing';

const Content = ({ i18n }) => (
  <ReactTemplate
    model={{ strong: text => <strong> {text}</strong> }}
    template={i18n.getString(_TL_(`
    We’ll consolidate the spend {{strong}}before{{/strong}} removing this billing group according to its existing settings.
    The spend {{strong}}after{{/strong}} you remove this billing group will follow the new settings.
  `))}
  />
);

export const BillingGroupDeletionDialog = ({
  onConfirm,
  onDecline,
}) => {
  const i18n = useContext(I18nContext);
  const styles = useStyles();

  return (
    <ConfirmDialog
      name="billing-group-deletion"
      dialogClassName={styles.customSizeModal}
      onConfirm={onConfirm}
      onDecline={onDecline}
      title={i18n.getString(_TL_('Delete billing group(s)'))}
      content={<Content i18n={i18n} />}
      confirmButtonText={i18n.getString(_TL_('Confirm and remove'))}
      declineButtonText={i18n.getString(_TL_('Cancel'))}
    />
  );
};

BillingGroupDeletionDialog.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onDecline: PropTypes.func.isRequired,
};
BillingGroupDeletionDialog.defaultProps = {
};
